<template>
  <div>
    <div class="bg-primary-100 flex items-center px-4 py-2">
      <w-button
        size="func"
        @click="toggleAllDetail = !toggleAllDetail"
      >
        {{ isAllDetailOpened ? '收合詳細內容' : '展開詳細內容' }}
      </w-button>
      <span class="ml-2 text-sm">
        點擊可以一併展開訂購品項人員資訊
      </span>
    </div>
    <b-table
      :data="items"
      :opened-detailed="openedRowDetail"
      :row-class="itemRowClass"
      :show-detail-icon="false"
      class="item-table"
      custom-detail-row
      default-sort="name"
      detail-key="id"
      detailed
      hoverable
      scrollable
    >
      <b-table-column
        :th-attrs="columnThAttrs"
        field="index"
        label="No."
        v-slot="props"
        width="28px"
      >
        {{ props.index + 1 }}.
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        field="quantity"
        label="數量"
        sortable
        v-slot="props"
        width="28px"
      >
        <span
          class="item-table__badge"
          :class="{ active: openedRowDetail.includes(props.row.id) }">
          {{ props.row.quantity }}
        </span>
      </b-table-column>
      <b-table-column
        :custom-sort="sortByEntree"
        :th-attrs="columnThAttrs"
        field="name"
        label="核對品項"
        sortable
        v-slot="props"
        width="400px"
      >
        <div class="flex items-center justify-between p-0">
          <div>
            <b-checkbox
              :indeterminate="
                checkedMemberMapping[props.row.id] > 0 &&
                checkedMemberMapping[props.row.id] < props.row.members.length"
              :value="checkedMemberMapping[props.row.id] === props.row.members.length"
              @input="toggleAllMemberUnderItem(props.row)"
            />
            <span class="align-bottom">{{ props.row.entree.name }}</span>
          </div>
          <a
            href="#"
            @click.prevent="props.toggleDetails(props.row)"
          >
            <font-awesome-icon
              :icon="openedRowDetail.includes(props.row.id) ? 'chevron-up' : 'chevron-down'"
            />
          </a>
        </div>
      </b-table-column>
      <b-table-column
        :custom-sort="sortByNote"
        :th-attrs="columnThAttrs"
        field="note"
        label="備註"
        sortable
        v-slot="props"
      >
        <div class="inline-block leading-6">
          <template v-for="option in sortOptions(props.row.entree.options)">
            <span
              v-for="item in option.items"
              :key="`option-item-${item.index}`"
              class="option"
            >
              {{ item.name }}{{ item.price ? formatPrice(item.price) : '' }}
            </span>
          </template>
        </div>
        {{ props.row.note ? `#${props.row.note}` : '' }}
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="text-right"
        field="price"
        header-class="text-right"
        label="單價"
        sortable
        v-slot="props"
        width="120px"
      >
        {{ props.row.price | commaFormat | priceFormat }}
      </b-table-column>
      <b-table-column
        :th-attrs="columnThAttrs"
        cell-class="text-right"
        field="subtotal"
        header-class="text-right"
        label="小計"
        sortable
        v-slot="props"
        width="120px"
      >
        {{ props.row.subtotal | commaFormat | priceFormat }}
      </b-table-column>

      <template #detail="props">
        <tr
          v-for="(member, memberIndex) in props.row.members"
          :key="`member-${memberIndex}-${props.row.id}`"
          class="detail-row">
          <td colspan="2" class="detail-row__indicator">&nbsp;</td>
          <td class="has-text-left">
            <b-checkbox v-model="member.checked" class="align-middle" />
            <span class="detail-row__amount">{{ member.quantity || '0' }}</span>
            <span
              :title="member.name">
              {{ member.name }}
            </span>
          </td>
          <td class="text-left">
            <span>{{ member.department_name }} {{ member.ext || '' }}</span>
          </td>
          <td>&nbsp;</td>
          <td>
            <span>
              {{ member.subtotal | commaFormat | priceFormat }}
            </span>
          </td>
        </tr>

      </template>

      <template #empty>
        <p class="my-12 text-center text-gray-700 text-sm">無已訂項目</p>
      </template>
    </b-table>
  </div>
</template>

<script>
import OrderItemTable from './OrderItemTable';

export default OrderItemTable;
</script>

<style lang="scss" scoped>
@import "./OrderItemTable";
</style>
